// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vEiLv","colBig":"styles_colBig__3fUgr","colSmall":"styles_colSmall__TR8NA","shopifyNameWrapper":"styles_shopifyNameWrapper__7-Kht"};